import React from "react";
import Button from "../../components/common/button";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {clearChangePasswordErrors} from "../../actions/users";
import {useDispatch} from "react-redux";
import {userCanAccess} from "../../utils/users";

const FIELD_LABELS = {
  email: 'Email',
  name: 'Name',
  role: 'Role',
  programAssociation: 'Program Association'
}

const ViewProfile = (props) => {
  const {
    myProfile,
    gotoEditAction
  } = props;

  const dispatch = useDispatch();

  const userRole = (myProfile) ? myProfile.userRoleList.find(element => element.id === parseInt(myProfile.user.roleId)) : {};
  const program = (myProfile) ? myProfile.programList.find(element => element.id === parseInt(myProfile.user.programId)) : {};

  const viewProfile = (myProfile) ? {
    email: myProfile.user.username,
    name: `${myProfile.user.firstName} ${myProfile.user.lastName}`,
    role: (userRole) ? myProfile.userRole.name : 'None',
    programAssociation: (program) ? myProfile.program.name : 'None'
  } : {};

  return (
    <div className='view-profile-info'>
      <div className='view-header'>
        <div className='view-title'>My Info</div>
        <div className='view-buttons'>
          <Button label='Edit' action={gotoEditAction}/>
        </div>
      </div>
      <div className='view-body'>
        <div className='view-items'>
          {Object.keys(viewProfile).map((element) => {
            return (
              <div key={`view-row-${element}`} className='my-info-row'>
                <div className='my-info-label'>
                  {FIELD_LABELS[element]}
                </div>
                <div className='my-info-value'>
                  {viewProfile[element]}
                </div>
              </div>
            );
          })}
          <div className='my-info-row'>
            <div className='my-info-label'>
            </div>
            <div className='my-info-value'>
              {userCanAccess(myProfile, 'change-password') && <Link to='/change-password' onClick={() => dispatch(clearChangePasswordErrors())}>Change Password</Link>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ViewProfile.propTypes = {
  myProfile: PropTypes.object,
  gotoEditAction: PropTypes.func.isRequired
}

export default ViewProfile;